module.exports = __webpack_public_path__ + "c1c0b543c5ecf05a52a1d74bb0a0185d.fbx";